/* Free Wash Bag for email signups: adds or removes the gift as the cart changes. Settings come from the
   cart drawer section (#cart-signup-gift-config). Moved out of sections/cart-drawer.liquid so it is cached. */
(function () {
  'use strict';

  if (window.__canchaSignupGiftLoaded) return;
  var configElement = document.getElementById('cart-signup-gift-config');
  if (!configElement) return;
  window.__canchaSignupGiftLoaded = true;
  var CONFIG = JSON.parse(configElement.textContent);

  const GWP_KEY = 'cancha_klaviyo_gwp';
  const THRESHOLD_CENTS = CONFIG.thresholdCents;
  const VARIANT_ID = parseInt(CONFIG.variantId, 10);
  const LEGACY_VARIANT_IDS = [41951693635658].filter(function (id) {
    return id !== VARIANT_ID;
  });
  let syncing = false;
  let syncPending = false;
  const CART_ROOT = window.Shopify?.routes?.root || '/';

  function isEligible() {
    return localStorage.getItem(GWP_KEY) === '1';
  }

  function setEligible() {
    localStorage.setItem(GWP_KEY, '1');
  }

  function findGift(cart) {
    return cart.items.find(function (item) {
      return item.variant_id === VARIANT_ID &&
        item.properties &&
        item.properties['_gift'] === 'true';
    });
  }

  function findLegacyGifts(cart) {
    return cart.items.filter(function (item) {
      return LEGACY_VARIANT_IDS.includes(item.variant_id) &&
        item.properties &&
        item.properties['_gift'] === 'true';
    });
  }

  async function addGift() {
    const response = await fetch(CART_ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: VARIANT_ID, quantity: 1, properties: { '_gift': 'true' } }]
      })
    });
    if (!response.ok) throw new Error('Could not add signup gift');
  }

  async function removeGift(key) {
    const response = await fetch(CART_ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (!response.ok) throw new Error('Could not remove signup gift');
  }

  async function syncGift() {
    if (!isEligible()) return;
    if (syncing) {
      syncPending = true;
      return;
    }
    syncing = true;
    try {
      // Read cart and customer eligibility together after cart changes.
      var res = await fetch(CART_ROOT + '?section_id=signup-gift-eligibility', { cache: 'no-store' });
      if (!res.ok) throw new Error('Could not check signup gift eligibility');
      var html = new DOMParser().parseFromString(await res.text(), 'text/html');
      var stateElement = html.querySelector('[data-signup-gift-eligibility]');
      if (!stateElement) throw new Error('Signup gift eligibility is unavailable');
      var state = JSON.parse(stateElement.textContent);
      var cart = state.cart;
      var gift = findGift(cart);
      var legacyGifts = findLegacyGifts(cart);
      var qualifies = state.qualifyingSubtotal >= THRESHOLD_CENTS && !state.returningCustomer;
      var changed = false;

      for (const legacyGift of legacyGifts) {
        await removeGift(legacyGift.key);
        changed = true;
      }

      // Preserve just one marked signup reward. Additional units would
      // otherwise remain paid now that checkout caps the gift at one.
      for (const extraGift of cart.items.filter(function (item) {
        return item.variant_id === VARIANT_ID && item.properties &&
          item.properties['_gift'] === 'true' && gift && item.key !== gift.key;
      })) {
        await removeGift(extraGift.key);
        changed = true;
      }

      if (qualifies && !gift) {
        await addGift();
        changed = true;
      } else if (gift && !qualifies) {
        await removeGift(gift.key);
        changed = true;
      } else if (gift && gift.quantity > 1) {
        var response = await fetch(CART_ROOT + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: 1 })
        });
        if (!response.ok) throw new Error('Could not update signup gift quantity');
        changed = true;
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('[Cancha GWP]', err);
    } finally {
      syncing = false;
      if (syncPending) {
        syncPending = false;
        syncGift();
      }
    }
  }

  var FORM_ID = CONFIG.formId;
  var DISMISS_KEY = 'cancha_gwp_dismissed';
  var DESIGN_MODE = CONFIG.designMode;

  function isDismissed() {
    return localStorage.getItem(DISMISS_KEY) === '1';
  }

  function setDismissed() {
    localStorage.setItem(DISMISS_KEY, '1');
  }

  function clearDismissed() {
    localStorage.removeItem(DISMISS_KEY);
  }

  function syncCtaVisibility() {
    if (DESIGN_MODE) return;
    var ctas = document.querySelectorAll('cancha-gwp-cta');
    ctas.forEach(function (cta) {
      cta.removeAttribute('hidden');
      var signedUp = isEligible() || cta.dataset.giftAdded === 'true';
      var button = cta.querySelector('.cancha-gwp-cta__button');
      if (button) button.hidden = signedUp;
      var form = cta.querySelector('[data-gwp-signup]');
      if (form) {
        form.hidden = signedUp || button?.getAttribute('aria-expanded') !== 'true';
        if (signedUp && button) button.setAttribute('aria-expanded', 'false');
      }
      if (signedUp) {
        cta.querySelector('.cancha-gwp-cta__heading').textContent = cta.dataset.signedUpHeading;
        cta.querySelector('.cancha-gwp-cta__subtext').textContent = cta.dataset.signedUpTerms;
      }
    });
  }

  function openKlaviyoForm() {
    if (!FORM_ID) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  }

  // Check URL query param on page load (e.g. ?gwp=FORM_ID)
  (function () {
    var params = new URLSearchParams(window.location.search);
    var gwpParam = params.get('gwp');
    if (gwpParam !== null && (!FORM_ID || gwpParam === FORM_ID)) {
      setEligible();
      params.delete('gwp');
      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
      history.replaceState(null, '', newUrl);
      syncGift();
    }
  })();

  window.addEventListener('cancha:chat-newsletter-signup', function () {
    setEligible();
    clearDismissed();
    syncGift();
    syncCtaVisibility();
  });

  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || (FORM_ID && e.detail.formId !== FORM_ID)) return;
    if (e.detail.type === 'submit') {
      setEligible();
      clearDismissed();
      syncGift();
      syncCtaVisibility();
    } else if (e.detail.type === 'close' && !isEligible()) {
      setDismissed();
      syncCtaVisibility();
    }
  });

  document.addEventListener('cart:change', function (e) {
    var cartData = e.detail && e.detail.cart;
    if (cartData && cartData.__canchaPartial) return;

    syncGift();
  });

  document.addEventListener('cart-drawer:refreshed', syncCtaVisibility);

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-gwp-signup]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-gwp-status]');
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.textContent = '';
    try {
      var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(form.dataset.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
        signal: AbortSignal.timeout(15000),
        body: JSON.stringify({ data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Cart Wash Bag newsletter signup',
            profile: { data: { type: 'profile', attributes: {
              email: input.value.trim(),
              subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
        } })
      });
      if (response.status !== 202) throw new Error('Newsletter signup failed with status ' + response.status);
      setEligible();
      clearDismissed();
      input.value = '';
      syncCtaVisibility();
      await syncGift();
    } catch (error) {
      // Klaviyo's bot protection sometimes blocks this request (a 403 page the
      // browser reports as a network error). Klaviyo's own signup form still
      // works then, and submitting it unlocks the gift through the listener above.
      console.error('[Cancha GWP]', error);
      if (FORM_ID) {
        status.textContent = form.dataset.errorFallback || form.dataset.error;
        openKlaviyoForm();
      } else {
        status.textContent = form.dataset.error;
      }
    } finally {
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cancha-gwp-cta__button');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('cancha-gwp-cta').querySelector('[data-gwp-signup]');
    if (form) {
      var expanded = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(expanded));
      form.hidden = !expanded;
      if (expanded) form.querySelector('input[type="email"]').focus({ preventScroll: true });
    } else {
      openKlaviyoForm();
    }
  });

  syncCtaVisibility();
  syncGift();
})();
